import React from "react";
import video from "../assets/video.mp4";
import Banner from "../components/Banner";
import { useTranslation } from "react-i18next";
import WhyChooseUs from "../components/WhyChooseUs";
import PhotoGallery from "../components/PhotoGallery";
import WhatBenefits from "../components/WhatBenefits";
import IntroductionSection from "../components/IntroductionSection";
import ExcellenceStandardsSection from "../components/ExcellenceStandardsSection";

const Home = () => {
  const { i18n, t } = useTranslation();
  return (
    <div>
      <Banner
        videoSrc={video}
        title={t("whatSubzeroCryotherapy")}
        bannerInfo={t("elevateWellnessJourney")}
        buttonText={t("bookAppointent")}
      />
      {/* <ExcellenceStandardsSection /> */}
      <WhyChooseUs />
      <WhatBenefits />
      <PhotoGallery />
      <IntroductionSection />
    </div>
  );
};

export default Home;
